__turbopack_context__.v({
  "dropdown": "inputSelect-module__ZJZtAq__dropdown" + " " + __turbopack_context__.i(23484)["dropdown"],
  "error": "inputSelect-module__ZJZtAq__error" + " " + __turbopack_context__.i(367887)["error"],
  "input": "inputSelect-module__ZJZtAq__input" + " " + __turbopack_context__.i(367887)["input"],
  "label": "inputSelect-module__ZJZtAq__label" + " " + __turbopack_context__.i(367887)["label"],
  "option": "inputSelect-module__ZJZtAq__option" + " " + __turbopack_context__.i(23484)["option"],
  "root": "inputSelect-module__ZJZtAq__root" + " " + __turbopack_context__.i(367887)["root"],
  "section": "inputSelect-module__ZJZtAq__section",
  "sectionLeft": "inputSelect-module__ZJZtAq__sectionLeft",
  "sectionRight": "inputSelect-module__ZJZtAq__sectionRight",
  "wrapperLeft": "inputSelect-module__ZJZtAq__wrapperLeft",
  "wrapperRight": "inputSelect-module__ZJZtAq__wrapperRight",
});
